import { render, staticRenderFns } from "./SeeBindCustomers.vue?vue&type=template&id=3b90d828&scoped=true&"
import script from "./SeeBindCustomers.vue?vue&type=script&lang=ts&"
export * from "./SeeBindCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./SeeBindCustomers.vue?vue&type=style&index=0&id=3b90d828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b90d828",
  null
  
)

export default component.exports